import { render, staticRenderFns } from "./HeaderActions.vue?vue&type=template&id=355da0f9"
import script from "./HeaderActions.vue?vue&type=script&lang=ts"
export * from "./HeaderActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports